import { render, staticRenderFns } from "./ClozeTest.vue?vue&type=template&id=2f749554&scoped=true&"
import script from "./ClozeTest.vue?vue&type=script&lang=js&"
export * from "./ClozeTest.vue?vue&type=script&lang=js&"
import style0 from "./ClozeTest.vue?vue&type=style&index=0&id=2f749554&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f749554",
  null
  
)

export default component.exports